import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const WorkIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled, size }}>
    <svg xmlns="http://www.w3.org/2000/svg" width={'50%'} height={'50%'} viewBox="0 0 16.244 18.5">
      <defs>
        <clipPath>
          <rect width="16.244" height="18.5" fill="none" />
        </clipPath>
      </defs>
      <g clipPath="url(#clipPath)">
        <path
          d="M15.284,5.682c0,.105-.052.21-.157.21h-4.67c-.1,0-.158-.105-.158-.21V.96"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
        <path
          d="M15.494,5.682V17.12a.7.7,0,0,1-.735.63H1.485a.667.667,0,0,1-.735-.63V1.38A.7.7,0,0,1,1.485.75h8.762Z"
          fill="none"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
        />
      </g>
    </svg>
  </CircledIcon>
);
